import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  selector: '[wilsonOnlyNumber]',
  standalone: false,
})
export class OnlyNumberDirective {
  private _el = inject(ElementRef);

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value;
    this._el.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
    if (initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
